import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=1ff89c9e&"
import script from "./tagInput.vue?vue&type=script&lang=js&"
export * from "./tagInput.vue?vue&type=script&lang=js&"
import style0 from "./tagInput.vue?vue&type=style&index=0&id=1ff89c9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports